import { updated } from "../actions";

const updateInfoThunk = (book) => {
  return async (dispatch, getState) => {
    const response = await fetch(`http://localhost:9000/books/${book?.id}`, {
      method: "PATCH",
      body: JSON.stringify(book),
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
    });
    const updatedBook = await response.json();
    dispatch(updated(updatedBook));
  };
};

export default updateInfoThunk;
